import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { asyncAction } from "../util/redux.js";
export var loadRentObjects = function loadRentObjects(contractType, stationId, pickupStationId) {
  return /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(dispatch, getState, context) {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return dispatch(asyncAction({
              typePrefix: "RENT_OBJECTS/RENT_OBJECTS",
              loadPayload: function loadPayload() {
                return context.api.rentObjects.getRentObjectTypes({
                  contractType: contractType,
                  stationId: stationId,
                  pickupStationId: pickupStationId
                });
              }
            }));
          case 2:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function (_x, _x2, _x3) {
      return _ref.apply(this, arguments);
    };
  }();
};